// Delivered mail to the recipient of a parcel (#2993): the customer's mails per country and the shop account's mail

export const defaultDeliveredEmailSubject = 'Je zending is bezorgd'

export const defaultDeliveredEmailBody = `Beste {naam},

Je zending is bezorgd. Bedankt voor je bestelling!

Met vriendelijke groet,
{bedrijfsnaam}`

/** The two switched off mails every customer starts with: the Netherlands and the other countries. */
export function defaultCustomerDeliveredEmails() {
    return [
        {enabled: false, language: 'NL', country: 'NL', senderName: '', replyTo: '', subject: defaultDeliveredEmailSubject, body: defaultDeliveredEmailBody},
        {enabled: false, language: 'EN', country: '', default: true, senderName: '', replyTo: '', subject: defaultDeliveredEmailSubject, body: defaultDeliveredEmailBody}
    ]
}

export function defaultDeliveredEmail() {
    return {sendDeliveredEmails: false, senderName: '', replyToEmail: '', emailSubject: defaultDeliveredEmailSubject, emailBody: defaultDeliveredEmailBody}
}
